import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function SurveySmartInsightsPage() {
  return <ResponsivePage.Body>SurveySmartInsightsPage</ResponsivePage.Body>
}
